/**
 * Product URL utilities for SEO-friendly URL structure
 * Format: /:category/:brand/:sku
 * Example: /ro-membranes/hydranautics/cpa3
 */

/**
 * Determines the category slug based on product type and title
 */
export function getProductCategory(productType?: string, title?: string): 'ro-membranes' | 'pressure-vessels' {
  const type = productType?.toLowerCase() || '';
  const productTitle = title?.toLowerCase() || '';
  
  if (type.includes('vessel') || productTitle.includes('vessel') || productTitle.includes('pressure')) {
    return 'pressure-vessels';
  }
  
  // Default to membranes for RO products
  return 'ro-membranes';
}

/**
 * Normalizes brand name for URL (lowercase, hyphenated)
 */
export function normalizeBrandSlug(vendor?: string): string {
  if (!vendor) return 'unknown';
  return vendor
    .toLowerCase()
    .replace(/\s+/g, '-')
    .replace(/[^a-z0-9-]/g, '');
}

/**
 * Generates the new SEO-friendly product URL
 */
export function getProductUrl(product: {
  handle: string;
  vendor?: string;
  productType?: string;
  title?: string;
}): string {
  const category = getProductCategory(product.productType, product.title);
  const brand = normalizeBrandSlug(product.vendor);
  return `/${category}/${brand}/${product.handle}`;
}

/**
 * Generates the full canonical URL for a product
 */
export function getProductCanonicalUrl(product: {
  handle: string;
  vendor?: string;
  productType?: string;
  title?: string;
}): string {
  return `https://aquaquote.com${getProductUrl(product)}`;
}

/**
 * Category display names for breadcrumbs
 */
export const CATEGORY_NAMES: Record<string, string> = {
  'ro-membranes': 'RO Membranes',
  'pressure-vessels': 'Pressure Vessels',
};

/**
 * Category paths for collection pages
 */
export const CATEGORY_PATHS: Record<string, string> = {
  'ro-membranes': '/ro-membranes',
  'pressure-vessels': '/pressure-vessels',
};
